module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-social"
  }, [_c('div', {
    staticClass: "custom-home-social__container"
  }, [_c('div', {
    staticClass: "custom-home-social__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-social__social-links"
  }, _vm._l((_vm.props.links), function(link, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-home-social__social-link",
      class: {
        'custom-home-social__social-link--active': _vm.socialSection === i
      },
      on: {
        "click": function($event) {
          return _vm.showSection(i)
        }
      }
    }, [_c('Icon', {
      staticClass: "custom-home-social__social-link-icon",
      attrs: {
        "name": link.icon
      }
    })], 1)
  }), 0), _c('div', {
    staticClass: "custom-home-social__ig-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.socialSection === parseInt("0")),
      expression: "socialSection === parseInt(\"0\")"
    }],
    staticClass: "custom-home-social__ig-section"
  }, [_c('a', {
    staticClass: "custom-home-social__follow-btn",
    attrs: {
      "href": _vm.props.links[0].href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Follow Us on Instagram ")]), _c('img', {
    staticClass: "custom-home-social__ig-bg",
    attrs: {
      "title": _vm.props.ig_bg.title,
      "src": _vm.props.ig_bg.url,
      "alt": _vm.props.ig_bg.alt
    }
  }), _c('Icon', {
    staticClass: "custom-home-social__ig-star",
    attrs: {
      "name": "star"
    }
  }), _c('swiper', {
    ref: "mySwiper",
    staticClass: "custom-home-social__slider-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props.slides), function(slide, j) {
    return _c('swiper-slide', {
      key: j,
      staticClass: "custom-home-social__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })
  }), 1), _c('div', {
    staticClass: "custom-home-social__next",
    on: {
      "click": function($event) {
        return _vm.slideNext()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _c('div', {
    staticClass: "custom-home-social__prev",
    on: {
      "click": function($event) {
        return _vm.slidePrev()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.socialSection === parseInt("1")),
      expression: "socialSection === parseInt(\"1\")"
    }],
    staticClass: "custom-home-social__facebook-section"
  }, [_c('a', {
    staticClass: "custom-home-social__follow-btn",
    attrs: {
      "href": _vm.props.links[1].href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Like Us on Facebook")]), _c('img', {
    staticClass: "custom-home-social__fb-image",
    attrs: {
      "src": _vm.props.fb_img
    }
  })])])]), _c('Icon', {
    staticClass: "custom-home-social__contact-mask",
    attrs: {
      "name": "patient-top-blue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bce4ee0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-social/custom-home-social.pug
// module id = 697
// module chunks = 1